const data = {
	"width": 48,
	"height": 48,
	"body": "<path fill=\"#2196F3\" d=\"m30.9 43l3.1-3.1L18.1 24L34 8.1L30.9 5L12 24z\"/>"
};
exports.__esModule = true;
exports.default = data;
